import { makeStyles, Theme } from '@material-ui/core'

import { FullScreenStepperActionsProps } from './FullScreenStepperActionsProps'

export const useFullScreenStepperActionsStyles = makeStyles<Theme, FullScreenStepperActionsProps>((theme) => ({
  root: {
    position: 'sticky',
    background: 'white',
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    borderTop: `${theme.spacing(0.5)}px solid ${theme.palette.grey[100]}`,
    zIndex: 3,
  },
  inlineEndActions: {
    '& > *': {
      marginInlineStart: theme.spacing(2),
    },
  },
  inlineStartActions: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginInlineEnd: theme.spacing(2),
    },
  },
}))
